<template>
  <div class="client-view">
    <!-- <div class="button">

    <a class="icon-btn nav-export" :href="`https://yoda-api.azurewebsites.net/report?searchTerm=${searchTerm}`" target="_blank">
      <font-awesome-icon icon="file-export" />
      <small>EXPORTAR</small>
    </a>
    </div>-->

    <Loading />
    <form @submit="searchSubscriber">
      <div class="form-group has-button">
        <input
          v-model="searchTerm"
          type="text"
          placeholder="Buscar por nombre de dominio  ó correo"
        />
        <button class="btn btn-primary" type="button" @click="searchSubscriber">
          <font-awesome-icon icon="search" />
          <span>Buscar</span>
        </button>
      </div>
    </form>
    <card v-if="toggleRegister">
      <h4 class="card-title">Información básica del Website</h4>
      <form action="#">
        <div class="inputs">
          <div class="form-group">
            <label for="clientName">DOMINIO</label>
            <input type="text" v-model="website.recaptcha_domain" required />
          </div>

          <div class="form-group">
            <label for="clientName">CAPTCHA WEB</label>
            <input
              type="text"
              v-model="website.recaptcha_website_key"
              required
            />
          </div>
          <div class="form-group">
            <label for="clientName">CAPTCHA SECRETA</label>
            <input
              type="text"
              v-model="website.recaptcha_secret_key"
              required
            />
          </div>
          <div class="form-group">
            <label for="clientName">CORREO</label>
            <input type="email" v-model="website.client_email_default" />
          </div>
          <div class="row">
            <div class="col-md-8">
              <div class="form-group">
                <label for="clientName">EMPRESA</label>
                <select name id v-model="website.recaptcha_country">
                  <option :value="null" disabled></option>
                  <option value="1">Caribe Media</option>
                  <option value="2">Axesa</option>
                </select>
              </div>
            </div>

            <div>
              <el-tooltip
                class="item"
                effect="dark"
                content="Para los clientes que administran sus propio servidor de correo"
                placement="top-start"
              >
                <el-checkbox
                  label="Propio servidor de correo"
                  name="type"
                  v-model="website.recaptch_own_service"
                ></el-checkbox>
              </el-tooltip>
            </div>
          </div>
        </div>
        <button class="btn btn-info" v-on:click.prevent="handlerClose">
          SALIR
        </button>
        <button
          class="btn btn-primary"
          v-on:click.prevent="usetUpdate"
          :disabled="!website.recaptcha_country"
        >
          GUARDAR
        </button>
      </form>
    </card>
    <card class="card" v-if="!toggleRegister">
      <div class="table-responsive">
        <table class="table" style="width:100%; table-layout: fixed;">
          <thead>
            <tr v-if="roll">
              <th colspan="7">
                <button
                  class="btn btn-primary"
                  v-on:click.prevent="handlerSaveDataCreate"
                >
                  Registrar website
                </button>
              </th>
            </tr>
            <tr>
              <th>ID</th>
              <th>DOMINIO</th>
              <th>CAPTCHA WEB</th>
              <th>CAPTCHA SECRETA</th>
              <th>CORREO</th>
              <th>EMPRESA</th>
              <th v-if="roll"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="website of websites" :key="website.recaptcha_id">
              <td
                style="max-width:120px; white-space: normal;word-wrap:break-word;"
              >
                <span class="iten-text-word">{{ website.recaptcha_id }}</span>
              </td>
              <td
                style="max-width:120px; white-space: normal;word-wrap:break-word;"
              >
                <span class="iten-text-word">{{
                  website.recaptcha_domain
                }}</span>
              </td>
              <td
                style="max-width:120px; white-space: normal;word-wrap:break-word;"
              >
                <span class="iten-text-word">{{
                  website.recaptcha_website_key
                }}</span>
              </td>
              <td
                style="max-width:120px; white-space: normal;word-wrap:break-word;"
              >
                <span class="iten-text-word">{{
                  website.recaptcha_secret_key
                }}</span>
              </td>
              <td
                style="max-width:120px; white-space: normal;word-wrap:break-word;"
              >
                <span class="iten-text-word">{{
                  website.client_email_default
                }}</span>
              </td>
              <td>
                {{ website.recaptcha_country == 1 ? "Caribe Media" : "Axesa" }}
              </td>
              <td v-if="roll">
                <button v-on:click.prevent="handlerSaveData(website)">
                  <font-awesome-icon icon="edit" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        @current-change="changePage($event)"
        @prev-click="changePage($event)"
        @next-click="changePage($event)"
      ></el-pagination>
    </card>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";

import Loading from "@/components/Card/Loading.vue";
export default {
  name: "client-consult",
  components: {
    Loading
  },
  data() {
    return {
      searchTerm: "",
      total: 0,
      toggleRegister: false,
      roll: false,
      website: {
        recaptcha_id: null,
        recaptch_own_service: null,
        recaptcha_domain: null,
        recaptcha_website_key: null,
        recaptcha_country: null,
        recaptcha_secret_key: null,
        client_email_default: null
      },
      websites: []
    };
  },
  created: async function() {
    if (localStorage.getItem("roll") === "Administrator") {
      this.roll = true;
    }
  },
  mounted() {
    this.getWebSite();
  },
  methods: {
    handlerClose() {
      this.toggleRegister = false;
    },
    getWebSite(word = null, offset = 0, limit = 10) {
      let _this = this;
      let _word = word ? "word=" + word : "not=not";
      let _offset = offset ? "offset=" + offset : "offset=0";
      let _limit = limit ? "limit=" + limit : "limit=10";

      this.$axios
        .get(
          `${process.env.VUE_APP_API_BASE_URL}/recaptcha?${_word}&${_offset}&${_limit}`
        )
        .then(resp => {
          _this.websites = [];
          _this.websites = resp.data.result;
          _this.total = parseInt(resp.data.total || 0);
        });
    },
    usetUpdate() {
      if (this.website.recaptcha_id) {
        this.updateeWebSite();
      } else {
        this.createWebSite();
      }
      this.getWebSite();
    },
    createWebSite() {
      let _this = this;
      this.$axios
        .post(`${process.env.VUE_APP_API_BASE_URL}/recaptcha`, this.website)
        .then(() => {
          Swal.fire({
            title: "Website registrado",
            type: "success"
          }).then(result => {
            if (
              /* Read more about handling dismissals below */
              result
            ) {
              _this.handlerSaveDataCreate();
              _this.toggleRegister = false;
              _this.getWebSite();
            }
          });
        });
    },

    updateeWebSite() {
      let _this = this;
      this.$axios
        .put(`${process.env.VUE_APP_API_BASE_URL}/recaptcha`, this.website)
        .then(() => {
          Swal.fire({
            title: "Website actualizado",
            type: "success"
          }).then(result => {
            if (
              /* Read more about handling dismissals below */
              result
            ) {
              _this.handlerSaveDataCreate();
              _this.toggleRegister = false;
              _this.getWebSite();
            }
          });
        });
    },
    handlerSaveData(data) {
      this.toggleRegister = true;
      this.website = data;
    },
    handlerSaveDataCreate() {
      this.toggleRegister = true;
      this.website = {
        recaptcha_id: null,
        recaptcha_domain: null,
        recaptcha_website_key: null,
        recaptcha_secret_key: null,
        recaptcha_country: null,
        client_email_default: null
      };
    },
    searchSubscriber() {
      this.getWebSite(this.searchTerm);
    },
    changePage(page) {
      this.getWebSite(
        this.searchTerm,
        parseInt((page >= 1 ? page - 1 : page) * 10),
        10
      );
    },

    ...mapActions(["GetClients", "token"])
  },
  computed: {
    ...mapGetters(["subscribers"])
  }
};
</script>
<style>
.el-pagination {
  text-align: center;
}

.table-responsive::-webkit-scrollbar {
    height: 15px;
}

.iten-text-word {
  display: inline-block;
  max-width: 150px;
}
</style>
